import { Component, input, model } from '@angular/core';

@Component({
  selector: 'oes-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
  title = input.required<string>();
  isOpen = model<boolean>(false);

  toggle(): void {
    this.isOpen.set(!this.isOpen());
  }
}
